module.exports = __webpack_public_path__ + "img/bannerParams.f09f49f7.jpg";